import { makeGetRequest, makePostRequest, makeDeleteRequest, makePutRequest } from 'utils/api'
import { Spend } from 'components/common/Spend'
import s from './CompanySpend.scss'

const CompanySpend = ({ id }) => {
  const makeSpendGetRequest = async () => id && (await makeGetRequest(`/v1/companies/${id}/spend`))

  const makeSpendPostRequest = async itemDetails =>
    await makePostRequest(`/v1/companies/${id}/spend`, itemDetails)

  const makeSpendPutRequest = async (itemId, itemDetails) =>
    await makePutRequest(`/v1/companies/${id}/spend/item/${itemId}`, itemDetails)

  const makeSpendDeleteRequest = async itemId =>
    await makeDeleteRequest(`/v1/companies/${id}/spend/item/${itemId}`)

  return (
    <div className={s.spendWrapper}>
      <Spend
        makeGetRequest={makeSpendGetRequest}
        makePostRequest={makeSpendPostRequest}
        makePutRequest={makeSpendPutRequest}
        makeDeleteRequest={makeSpendDeleteRequest}
        isCompanySpend
      />
    </div>
  )
}

export default CompanySpend
